import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form, Checkbox, Dropdown } from 'semantic-ui-react';
import { Input } from '../../../lib/custom-ui';

import styles from '../SettingDashboard.module.scss';

const ComponentType2Form = React.memo(
  ({ devices, items, data, isSubmitting, onChangeField, onChangeEmptyField, isError }) => {
    const [t] = useTranslation();

    const devicesOptions = [];
    devices.forEach((item) => {
      devicesOptions.push({ key: item.id, value: item.id, text: item.name });
    });

    const itemsOptions = [];
    items.forEach((item) => {
      itemsOptions.push({ key: item.id, value: item.itemName, text: item.name });
    });

    const descriptionField = useRef(null);
    const titleField = useRef(null);
    const intervalField = useRef(null);

    // const positionOptions = [
    //   { key: 1, value: 1, text: 1 },
    //   { key: 2, value: 2, text: 2 },
    //   { key: 3, value: 3, text: 3 },
    //   { key: 4, value: 4, text: 4 },
    //   { key: 5, value: 5, text: 5 },
    //   { key: 6, value: 6, text: 6 },
    // ];
    const positionOptions = Array.from({ length: 20 }, (_, i) => {
      return { key: i + 1, value: i + 1, text: i + 1 };
    });

    const [positionError, setPositionError] = useState(false);
    const [deviceIdError, setDeviceIdError] = useState(false);
    const [itemNamesError, setItemNamesError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);
    const [titleError, setTitleError] = useState(false);
    const [intervalError, setIntervalError] = useState(false);
    useEffect(() => {
      setPositionError(isError.indexOf('position') !== -1);
      setDeviceIdError(isError.indexOf('deviceId') !== -1);
      setItemNamesError(isError.indexOf('itemNames') !== -1);
      setDescriptionError(isError.indexOf('description') !== -1);
      setTitleError(isError.indexOf('title') !== -1);
      setIntervalError(isError.indexOf('interval') !== -1);
    }, [isError]);

    return (
      <>
        <Form.Field required error={positionError} onFocus={() => setPositionError(false)}>
          <label htmlFor="position">{t('common.components.position')}</label>
          <Form.Select
            name="position"
            className={styles.field}
            placeholder={t('common.selectPosition')}
            search
            fluid
            selection
            value={data.position}
            options={positionOptions}
            onChange={onChangeField}
          />
        </Form.Field>
        <Form.Field required error={deviceIdError} onFocus={() => setDeviceIdError(false)}>
          <label htmlFor="deviceId">{t('common.components.devices')}</label>
          <Form.Select
            name="deviceId"
            className={styles.field}
            placeholder={t('common.selectDevice')}
            search
            fluid
            selection
            value={data.deviceId}
            options={devicesOptions}
            onChange={onChangeField}
          />
        </Form.Field>
        <Form.Field required error={itemNamesError} onFocus={() => setItemNamesError(false)}>
          <label htmlFor="itemNames">{t('common.components.items')}</label>
          <Dropdown
            multiple
            name="itemNames"
            className={styles.field}
            placeholder={t('common.selectItem')}
            search
            fluid
            selection
            value={data.itemNames}
            options={itemsOptions}
            onChange={onChangeField}
          />
        </Form.Field>
        <Form.Field required error={descriptionError} onFocus={() => setDescriptionError(false)}>
          <label htmlFor="description">{t('common.components.description')}</label>
          <Input
            fluid
            ref={descriptionField}
            name="description"
            value={data.description}
            readOnly={isSubmitting}
            className={styles.field}
            onChange={onChangeField}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            label={t('common.components.empty')}
            name="empty"
            defaultChecked={data.empty === true}
            readOnly={isSubmitting}
            onChange={onChangeEmptyField}
          />
        </Form.Field>
        <Form.Field required error={titleError} onFocus={() => setTitleError(false)}>
          <label htmlFor="title">{t('common.components.title')}</label>
          <Input
            fluid
            ref={titleField}
            name="title"
            value={data.title}
            readOnly={isSubmitting}
            className={styles.field}
            onChange={onChangeField}
          />
        </Form.Field>
        <Form.Field required error={intervalError} onFocus={() => setIntervalError(false)}>
          <label htmlFor="interval">{t('common.components.interval')}</label>
          <Input
            fluid
            type="number"
            ref={intervalField}
            name="interval"
            value={data.interval}
            readOnly={isSubmitting}
            className={styles.field}
            onChange={onChangeField}
          />
        </Form.Field>
      </>
    );
  },
);

ComponentType2Form.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onChangeField: PropTypes.func.isRequired,
  onChangeEmptyField: PropTypes.func.isRequired,
  isError: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default ComponentType2Form;
